export const getThumbnailCaptureTime = duration => {
    if (!Number.isFinite(duration) || duration <= 0) {
        return 0;
    }

    // Requirements: 10s capture for eligible videos, 5s for videos shorter than 10s.
    const preferredTime = duration < 10 ? 5 : 10;

    if (duration >= preferredTime) {
        return preferredTime;
    }

    // Ultra-short videos (<5s): clamp just inside the playable range.
    return Math.max(0, duration - 0.05);
};

export const generateVideoThumbnail = videoUrl => {
    if (!videoUrl || typeof window === 'undefined' || typeof document === 'undefined') {
        return Promise.resolve(null);
    }

    return new Promise(resolve => {
        try {
            const video = document.createElement('video');
            video.crossOrigin = 'anonymous';
            video.preload = 'metadata';
            video.muted = true;
            video.playsInline = true;

            const cleanup = () => {
                video.removeAttribute('src');
                video.load();
            };

            video.onerror = () => {
                cleanup();
                resolve(null);
            };

            video.onloadedmetadata = () => {
                const captureTime = getThumbnailCaptureTime(video.duration);
                video.currentTime = captureTime;
            };

            video.onseeked = () => {
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth || 1280;
                    canvas.height = video.videoHeight || 720;
                    const context = canvas.getContext('2d');

                    if (!context) {
                        cleanup();
                        resolve(null);
                        return;
                    }

                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const thumbnail = canvas.toDataURL('image/jpeg', 0.85);
                    cleanup();
                    resolve(thumbnail);
                } catch (e) {
                    cleanup();
                    resolve(null);
                }
            };

            video.src = videoUrl;
            video.load();
        } catch (e) {
            resolve(null);
        }
    });
};
